import React, { useEffect, useState } from 'react'
import { Container } from './styles'
import { Button, Snackbar, TextField } from '@material-ui/core'
import api from '../../config/api'
import { Alert } from '@material-ui/lab'
import Selector from "../../components/Selector";
import ReactDOM from 'react-dom';
import Modal from 'react-modal'

interface Stock {
    id: number
    branch_id: number
    product_id: number
    description: string
    quantity: number
    product: Product
}

interface Product {
    id: number
    name: string
    description: string
    value: number
    image: string
}

interface Props {
    stocks: Stock[]
    branch: number
}



const UpdateStock: React.FC<Props> = ({ stocks, branch }) => {
    //@ts-ignore
    const [updated, setUpdated] = useState<number[]>([])
    const [total, setTotal] = useState<number[]>([])

    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFailed, setOpenFailed] = useState(false);
    const [decreaseStock, setDecreaseStock] = React.useState(false);
    const [errorMessage, setErrorMessage] = useState("Erro desconhecido");


    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        event?.preventDefault()
        if (reason === 'clickaway') {
            return;
        }
        setOpenSuccess(false);
    };

    const handleCloseFailed = (event?: React.SyntheticEvent, reason?: string) => {
        event?.preventDefault()
        if (reason === 'clickaway') {
            return;
        }
        setOpenFailed(false);
    };

    function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) {
        const value = e.target.value
        if (!isNaN(Number(value))) {

            const auxUpdated = updated
            const auxTotal = total

            auxUpdated[index] = Number(value)
            if (decreaseStock) {
                auxTotal[index] = Number(stocks[index].quantity) - Number(value)
            } else {
                auxTotal[index] = Number(value) + Number(stocks[index].quantity)
            }
            setUpdated([...auxUpdated])
            setTotal([...auxTotal])
        }

    }

    async function handleSubmit() {
        const updatedStock: Stock[] = []


        updated.map((element, index) => {
            if (element !== 0) {
                if (decreaseStock) {
                    const auxStock = { ...stocks[index] }
                    auxStock.quantity = -element
                    updatedStock.push(auxStock)
                } else {
                    const auxStock = { ...stocks[index] }
                    auxStock.quantity = element
                    updatedStock.push(auxStock)
                }
            }
        })

        const responseUpdated = await api.put(`/stocks/updatebatch/${branch}`, {
            stocks: updatedStock,
        })
        if (responseUpdated.status === 204) {
            setOpenSuccess(true)
            window.location.reload();
        } else {
            setOpenFailed(true)
        }

    }

    useEffect(() => {
        stocks.map((stock: Stock, index: number) => {
            setUpdated(updated => [...updated, 0])
            setTotal(total => [...total, Number(stock.quantity)])
        })

    }, [])

    useEffect(() => {
        getProductDispatch()
        fetchProducts()
    }, [])


    async function fetchProducts() {
        const response = await api.get('/products')
        setProductsNames(response.data.products)
    }


    const [filterBranch, setBranchs] = useState<string | undefined>("-1")
    const [filterProduct, setProducts] = useState<string | undefined>("-1")
    const [filterName, setName] = useState<string | undefined>("-1")
    const [allOrders, setAllOrders] = useState<any[]>([])
    const [submitedTimes, setSubmitedTimes] = useState(0)

    const filter = {
        branch_id: filterBranch === "-1" ? undefined : filterBranch,
        product_id: filterProduct === "-1" ? undefined : filterProduct,
    }


    async function getProductDispatch() {

        const auxBranchs = await api.get('/branchs')
        setBranchs(auxBranchs.data.branchs)
        const auxProducts = await api.get('/products/')
        setProducts(auxProducts.data.products)



        const auxList = await api.get('/orders',
            {
                params: {
                    ...filter
                },

            })

        await setAllOrders(auxList.data.orders)
        //console.log(allOrders)
    }
    interface ProductObj {
        created_at: Date
        description: string
        id: number
        image: any
        name: string
        updated_at: Date
        value: number
    }
    interface ProductStockObj {
        id: number,
        product_id: number,
        quantity: number
    }

    const [sellQtd, setSellQuantity] = useState(0)
    const [currentObj, setCurrentObj] = React.useState({ product: {} as ProductObj })
    const [currentStock, setCurrentStock] = useState(0)
    const [currentSendQuantity, setCurrentSendQuantity] = useState(0)





    const [productsNames, setProductsNames] = useState([])


    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
        },
    };

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
    }

    function closeModal() {
        setIsOpen(false);
    }

    async function handleModal(product_id: number) {
        await getProductAditionalInformation(product_id)
    }


    const [product_id, setProductId] = useState(0)

    async function getProductAditionalInformation(product_id: number) {
        setProductId(product_id)
        console.log({
            product_id: product_id,
            branch_id: branch
        })
        try {
            const information = await api.post('orders/general',
                {
                    product_id: product_id,
                    branch_id: branch
                })
            const auxProduct = await api.get('/products/' + product_id)
            await setCurrentObj(auxProduct.data)
            await setCurrentStock(information.data[0].stock)
            await setSellQuantity(information.data[1].sells)
            openModal()
            return
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Container>
            <ul>
                <div className="field header">
                    Baixa em estoque?
                </div>
                <input type="checkbox"
                    defaultChecked={decreaseStock}
                    onChange={() => setDecreaseStock(!decreaseStock)}
                />
                <li>
                    <div className="field header">
                        Nome
                    </div>
                    <div className="field header">
                        Atual
                    </div>
                    <div className="field header">
                        Inserido/Retirado
                    </div>
                    <div className="field header">
                        Informações
                    </div>
                    <div className="field header">
                        Total
                    </div>
                </li>
                {
                    stocks.map((stock, index) =>
                        <li  >
                            <div className="field">
                                {stock.product.name}
                            </div>
                            <div className="field">
                                {Number(stock.quantity)}
                            </div >
                            <div className="field">
                                <TextField
                                    value={updated[index]}
                                    id="standard-basic"
                                    onChange={(event) => handleChange(event, index)}
                                />
                            </div>
                            <div className="field" style={{ color: updated[index] === 0 ? '' : updated[index] > 0 ? '#64C832' : '#ff0000' }}>
                                <Button
                                    onClick={() => handleModal(stock.product.id)}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    children="Sobre"
                                ></Button>
                            </div>
                            <div className="field" style={{ color: updated[index] === 0 ? '' : updated[index] > 0 ? '#64C832' : '#ff0000' }}>
                                {total[index]}
                            </div>
                        </li>
                    )
                }
            </ul>
            <Button variant="contained" color="secondary" style={{ margin: '20px 0px' }} onClick={handleSubmit}>
                Atualizar Estoque
            </Button>
            <Snackbar open={openSuccess} autoHideDuration={2000} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success">
                    Estoque atualizado com sucesso!
                </Alert>
            </Snackbar>
            <Snackbar open={openFailed} autoHideDuration={2000} onClose={handleCloseFailed}>
                <Alert onClose={handleCloseSuccess} severity="error">
                    Erro ao atualizar estoque!
                </Alert>
            </Snackbar>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                style={customStyles}
                contentLabel="Product Information Modal"
            >
                <h2>Informações Adicionais do produto {currentObj.product.name} na Unidade {branch}</h2>
                <div>Descrição: {currentObj.product.description}</div>
                <div>Valor: {currentObj.product.value} reais</div>
                <div>Quantidade em estoque: {currentStock}</div>
                <div>Quantidade de vendas: {sellQtd} </div>
                <div>Quantidade de vezes eviado a essa Unidade: {currentStock + sellQtd} </div>
                <div>Criado em: {currentObj.product.created_at}</div>
                <div>Atualizado em: {currentObj.product.updated_at}</div>
                <Button variant="contained" color="secondary" style={{ margin: '20px 0px' }} onClick={closeModal}>
                    Fechar
                </Button>
            </Modal>
        </Container>
    )
}

export default UpdateStock